import axios from "axios";

const API = axios.create({
//    baseURL: "http://localhost:8000/api",  
    // baseURL: "http://192.168.5.62:1234/api",  
    baseURL : "https://employee.pothysswarnamahalapp.com/api",
    headers: {
        "Content-Type": "application/json"
    }
});

export default API;